import { TextVariant, variantStyles } from '@/components/atomic/text'
import { cn } from '@/utils/shadcn/utils'

/**
 * Generates the appropriate className depending on the error state and size
 */

// Base layout and structure classes
const LAYOUT_CLASSES =
  'flex px-3 py-1 gap-2.5 items-center self-stretch transition-colors'

// Typography and text classes
const TEXT_CLASSES =
  'text-foreground placeholder:text-moment-blue-grey-400 dark:placeholder:text-moment-grey-400'

// Border and background classes
const BORDER_CLASSES =
  'border border-solid rounded-md border-primary-border bg-background'

// Focus state classes
const FOCUS_CLASSES = [
  'focus-visible:outline-hidden',
  'focus-visible:ring-2',
  'focus-visible:border-1',
  'focus-visible:border-moment-teal-600',
  'focus-visible:ring-moment-teal-500',
  'dark:focus-visible:border-moment-teal-500',
  'dark:focus-visible:ring-moment-teal-900',
]

// Disabled state classes
const DISABLED_CLASSES = [
  'disabled:cursor-not-allowed',
  'disabled:bg-moment-white-200',
  'dark:disabled:bg-moment-black-200',
  'dark:disabled:border-moment-blue-grey-1000',
  'dark:disabled:text-moment-grey-700',
]

// Error state classes
const ERROR_CLASSES = [
  'outline-hidden',
  'ring-2',
  'border-1',
  'border-moment-red-600',
  'ring-moment-red-200',
  'dark:border-moment-red-400',
  'dark:ring-moment-red-900',
]

// Text size mapping to match original Input component
const getTextSizeClass = (size?: 'small' | 'large') => {
  if (size === 'small') return variantStyles[TextVariant.BodySubtext] // 12px
  if (size === 'large') return variantStyles[TextVariant.BodySmall] // 13px
  return variantStyles[TextVariant.BodySmall] // default to large (13px)
}

export const getInputClassName = (
  hasError: boolean,
  className?: string,
  size?: 'small' | 'large',
) => {
  return cn(
    // Base classes
    LAYOUT_CLASSES,
    TEXT_CLASSES,
    BORDER_CLASSES,

    // Text size based on size prop
    getTextSizeClass(size),

    // State classes
    FOCUS_CLASSES,
    DISABLED_CLASSES,

    // Error state
    hasError && ERROR_CLASSES,

    // Custom className
    className,
  )
}
